import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { Deal } from "Types/api/Deal";
import { ApiVehicle } from "Types/api/Vehicle";
import { DealState, GarageRequestAccess, PaymentTypeOptions } from "Types/state";
import { UPDATE_DEAL_VEHICLES } from "../constants";
import { API, DealResponses } from "../dataService/types";
import { Tracking } from "Types/api/Tracking";

export interface UpdateAccessRequestAction {
    type: DealResponses.UpdateAccessRequest;
    data: DealState;
}

export interface UpdateDealVehiclesAction {
    type: UPDATE_DEAL_VEHICLES;
    data: { vehicles: ApiVehicle[] };
}

export function incrementDealRevision() {
    return {
        type: DealResponses.IncrementRevision,
    };
}

export function updateAccessRequest(accessRequest: GarageRequestAccess | null): UpdateAccessRequestAction {
    return {
        data: { accessRequest } as DealState,
        type: DealResponses.UpdateAccessRequest,
    };
}

export function updateDealVehicles(vehicles: ApiVehicle[]): UpdateDealVehiclesAction {
    return {
        data: { vehicles },
        type: UPDATE_DEAL_VEHICLES,
    };
}

// `tracking` is required because the backend dispatches DealCreatedEvent on deal create and requires the roxanne/facebook tracking IDs
export const postDealRequest = actionCreator(
    "deal/post/request",
    (env: string, accountSlug: string, tracking: Tracking, vin: string, paymentType?: PaymentTypeOptions) => ({
        env,
        accountSlug,
        tracking,
        vin,
        paymentType,
    }),
    () => ({ route: API.Deal })
);

export const getDealSuccess = actionCreator("deal/get/success", (deal: Deal) => ({ deal }));

export const updateUUID = actionCreator("uuid/update", (uuid: string) => ({ uuid }));

export const clearDealerChanges = actionCreator("dealerChanges/clear");

export const authenticationMergeRequest = actionCreator(
    "authentication/merge/request",
    (
        dealData: { uuid: string; verifiedUuid: string; garageKeyType: "email" | "sms"; vins: string[] },
        envConfig: { environment: string; slug: string },
        garageCreated: boolean
    ) => ({
        dealData,
        envConfig,
        garageCreated,
    }),
    () => ({ route: API.Deal })
);

export const authenticationMergeSuccess = actionCreator("authentication/merge/success", (deal: Deal) => ({
    deal,
}));
